// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CenterHtml {
    flex-direction: column;
    padding-bottom: 100px;
}

.CenterHtml-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    padding-bottom: 60px;
}

.CenterHtml-box {
    justify-content: center;
}

.CenterHtml-content {
    line-height: 100%;
    max-width: 700px;
    background: #fff;
    padding: 40px;
    border-radius: 32px;
}`, "",{"version":3,"sources":["webpack://./src/css/CenterHtml.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB","sourcesContent":[".CenterHtml {\n    flex-direction: column;\n    padding-bottom: 100px;\n}\n\n.CenterHtml-title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    align-self: stretch;\n    padding-bottom: 60px;\n}\n\n.CenterHtml-box {\n    justify-content: center;\n}\n\n.CenterHtml-content {\n    line-height: 100%;\n    max-width: 700px;\n    background: #fff;\n    padding: 40px;\n    border-radius: 32px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
